export const BROKER_FEE_PRODUCT_ID = 'b0ae5d9f-a146-41f0-8e31-b35d70380869';
//# sourceMappingURL=broker.js.map